// extracted by mini-css-extract-plugin
export default {"micro":"nKEhLLgaumb_rT6qoSkrd"};